import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import CarouselsApi from 'libs/api/website/carousels';

const useSingleCarousel = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const response = await CarouselsApi.show(routeId);
        const responseData = response.data;
        const carousel =
          responseData?.success && responseData?.carousel
            ? responseData.carousel
            : responseData?.carousel;

        if (!cancelled) {
          setSingleItem(carousel || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleCarousel;
